document.addEventListener('DOMContentLoaded', function() {
  
  function YardageCartQtySelector(el, options) {
    this.wrapper = el;
    this.options = Object.assign({}, {}, options);
    
    this.uniqueId = this.wrapper.getAttribute('data-yardage-cart-wrapper');
    this.yardageInput = this.wrapper.querySelector('[data-yardage-cart-input="' + this.uniqueId + '"]');
    this.hiddenInput = document.querySelector('[data-yardage-cart-hidden="' + this.uniqueId + '"]');
    this.builtinQtyInput = document.querySelector('[data-yardage-builtin-qty="' + this.uniqueId + '"]');
    this.minusButton = this.wrapper.querySelector('[data-yardage-cart-minus="' + this.uniqueId + '"]');
    this.plusButton = this.wrapper.querySelector('[data-yardage-cart-plus="' + this.uniqueId + '"]');
    this.labelElement = this.wrapper.querySelector('[data-yardage-cart-label="' + this.uniqueId + '"]');
    
    if (!this.yardageInput || !this.hiddenInput || !this.builtinQtyInput) {
      console.warn('Yardage cart selector missing required elements');
      return;
    }
    
    this.init();
  }
  
  YardageCartQtySelector.prototype = Object.assign({}, YardageCartQtySelector.prototype, {
    init: function() {
      this.yardageInput.addEventListener('input', this.handleInputChange.bind(this));
      this.yardageInput.addEventListener('blur', this.handleInputBlur.bind(this));
      this.yardageInput.addEventListener('keydown', this.handleKeyDown.bind(this));
      
      if (this.minusButton) {
        this.minusButton.addEventListener('click', this.handleMinus.bind(this));
      }
      
      if (this.plusButton) {
        this.plusButton.addEventListener('click', this.handlePlus.bind(this));
      }
      
      this.updateLabel(parseFloat(this.yardageInput.value) || 0);
    },
    
    handleInputChange: function() {
      let value = parseFloat(this.yardageInput.value);
      
      if (isNaN(value) || value < 0) {
        value = 0;
      }
      
      if (value > 0 && value < 0.25) {
        value = 0.25;
      }
      
      if (value > 0) {
        value = Math.round(value * 4) / 4;
      }
      
      this.yardageInput.value = value === 0 ? '0' : value.toString();
      this.updateBuiltinQuantity(value, false);
      this.updateLabel(value);
    },
    
    handleInputBlur: function() {
      this.triggerBuiltinQuantityChange();
    },
    
    handleKeyDown: function(e) {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
        if (e.key === 'ArrowUp') {
          this.handlePlus();
        } else {
          this.handleMinus();
        }
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        this.triggerBuiltinQuantityChange();
      }
    },
    
    handleMinus: function() {
      let currentValue = parseFloat(this.yardageInput.value) || 0;
      let newValue;
      
      if (currentValue <= 0.25) {
        newValue = 0;
      } else {
        newValue = currentValue - 0.25;
      }
      
      this.yardageInput.value = newValue === 0 ? '0' : newValue.toString();
      this.updateBuiltinQuantity(newValue, true);
      this.updateLabel(newValue);
    },
    
    handlePlus: function() {
      let currentValue = parseFloat(this.yardageInput.value) || 0;
      let newValue = currentValue === 0 ? 0.25 : currentValue + 0.25;
      
      this.yardageInput.value = newValue.toString();
      this.updateBuiltinQuantity(newValue, true);
      this.updateLabel(newValue);
    },
    
    updateBuiltinQuantity: function(yardageValue, triggerChange) {
      const cartQuantity = yardageValue === 0 ? 0 : Math.max(1, Math.round(yardageValue * 4));
      
      this.hiddenInput.value = cartQuantity;
      this.builtinQtyInput.value = cartQuantity;
      
      console.log('Updated built-in quantity:', {
        yardage: yardageValue,
        cartQuantity: cartQuantity,
        willTriggerChange: triggerChange
      });
      
      if (triggerChange) {
        this.triggerBuiltinQuantityChange();
      }
    },
    
    triggerBuiltinQuantityChange: function() {
      console.log('Triggering built-in quantity change');
      
      this.wrapper.classList.add('is-loading');
      
      const inputEvent = new Event('input', { bubbles: true });
      const changeEvent = new Event('change', { bubbles: true });
      
      this.builtinQtyInput.dispatchEvent(inputEvent);
      this.builtinQtyInput.dispatchEvent(changeEvent);
      
      setTimeout(() => {
        this.wrapper.classList.remove('is-loading');
      }, 500);
    },
    
    updateLabel: function(value) {
      if (!this.labelElement) return;
      
      const singularLabel = this.labelElement.getAttribute('data-label');
      const pluralLabel = this.labelElement.getAttribute('data-label-plural');
      
      if (value === 1) {
        this.labelElement.textContent = singularLabel;
      } else {
        this.labelElement.textContent = pluralLabel;
      }
    }
  });
  
  function initYardageCartSelectors() {
    const yardageWrappers = document.querySelectorAll('[data-yardage-cart-wrapper]:not(.yardage-cart-initialized)');
    
    console.log('Initializing', yardageWrappers.length, 'yardage cart selectors');
    
    yardageWrappers.forEach(function(wrapper) {
      wrapper.classList.add('yardage-cart-initialized');
      
      console.log('Initializing yardage selector (simplified approach)');
      
      new YardageCartQtySelector(wrapper);
    });
  }
  
  initYardageCartSelectors();
  
  document.addEventListener('cart:updated', function(event) {
    console.log('Cart updated, reinitializing yardage selectors');
    
    setTimeout(() => {
      document.querySelectorAll('[data-yardage-cart-wrapper]').forEach(wrapper => {
        wrapper.classList.remove('is-loading');
      });
      
      initYardageCartSelectors();
    }, 100);
  });
  
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const hasYardageElements = addedNodes.some(function(node) {
          return node.nodeType === 1 && 
                 (node.querySelector && node.querySelector('[data-yardage-cart-wrapper]') || 
                  node.hasAttribute && node.hasAttribute('data-yardage-cart-wrapper'));
        });
        
        if (hasYardageElements) {
          shouldReinit = true;
        }
      }
    });
    
    if (shouldReinit) {
      setTimeout(function() {
        document.querySelectorAll('[data-yardage-cart-wrapper]').forEach(wrapper => {
          wrapper.classList.remove('yardage-cart-initialized', 'is-loading');
        });
        initYardageCartSelectors();
      }, 50);
    }
  });
  
  const cartContainers = document.querySelectorAll('[data-products], .cart__page-col, .drawer__contents');
  cartContainers.forEach(function(container) {
    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    }
  });
});
